export var EarlyAccessPhase;
(function (EarlyAccessPhase) {
    EarlyAccessPhase["Invalid"] = "INVALID";
    EarlyAccessPhase["BuildUp"] = "BUILD_UP";
    EarlyAccessPhase["EarlyAccess"] = "EARLY_ACCESS";
    EarlyAccessPhase["GeneralAccess"] = "GENERAL_ACCESS";
    EarlyAccessPhase["PreEarlyAccess"] = "PRE_EARLY_ACCESS";
})(EarlyAccessPhase || (EarlyAccessPhase = {}));
export var PlusMembershipStatus;
(function (PlusMembershipStatus) {
    PlusMembershipStatus["Eligible"] = "ELIGIBLE";
    PlusMembershipStatus["Member"] = "MEMBER";
    PlusMembershipStatus["NotEligible"] = "NOT_ELIGIBLE";
})(PlusMembershipStatus || (PlusMembershipStatus = {}));
export var PlusMembershipType;
(function (PlusMembershipType) {
    PlusMembershipType["Trial"] = "TRIAL";
    PlusMembershipType["Base"] = "BASE";
    PlusMembershipType["None"] = "NONE";
})(PlusMembershipType || (PlusMembershipType = {}));
export var CampaignEarlyAccessState;
(function (CampaignEarlyAccessState) {
    CampaignEarlyAccessState["Active"] = "ACTIVE";
    CampaignEarlyAccessState["Expired"] = "EXPIRED";
})(CampaignEarlyAccessState || (CampaignEarlyAccessState = {}));
